export const PERMISSION_ORDER = [
    "required_access",
    "settings",
    "records",
    "reports/logs",
    "campaigns",
    "groups_subgroups",
    "calendar",
    "dashboards",
];

export const SETTINGS_ORDER = {
    general_settings: [
        "users",
        "teams",
        "schedule",
        "permissions",
        "territories",
    ],
    account_management: ["company_profile", "billing", "usage_stats"],
    phone_management: [],
    "texting/tcr": [
        "brand_registration",
        "campaign_registration",
        "texting_preferences",
    ],
    integrations_data_import: ["web_forms", "import_data", "data_providers"],
    crm_customization: [
        "activities",
        "library",
        "product_catalog",
        "pipeline",
        "data_customization",
    ],
    automation: ["sequences", "assignment_rules"],
    reports_and_logs: [
        "data_integration_log/_data_mapping",
        "sequence_report",
        "quotes_&_orders_report",
        "invoices_report",
        "call_history_report",
        "text_history_report",
        "pipeline_history_report",
        "archive"
    ],
};

export const sortByOrder = (obj = {}, order = []) => {
    if (!obj || typeof obj !== "object") return obj;

    const ordered = order
        ?.filter?.((key) => key in obj)
        ?.reduce?.((acc, key) => {
            acc[key] = obj[key];
            return acc;
        }, {});

    const remaining = Object.keys(obj)
        ?.filter?.((key) => !order?.includes?.(key))
        ?.reduce?.((acc, key) => {
            acc[key] = obj[key];
            return acc;
        }, {});

    return {
        ...ordered,
        ...remaining,
    };
};
